import ZebraBrowserPrinterWrapper from '@/utils/zebraBrowserPrinter/zebraBrowserPrinterWrapper';
import { getErrorMessage } from '@/utils/error';

export const sendPrintMessage = async (zpl: string) => {
  try {
    const browserPrint = new ZebraBrowserPrinterWrapper();
    const defaultPrinter = await browserPrint.getDefaultPrinter();
    if (defaultPrinter) {
      browserPrint.setPrinter(defaultPrinter);
      await browserPrint.checkPrinterStatus();
      await browserPrint.print(zpl);
    }
  } catch (error) {
    throw new Error(getErrorMessage(error));
  }
};
